// extracted by mini-css-extract-plugin
export default {"Create":"Create_Create__tRZHO","content":"Create_content__PoEsO","uploadContainer":"Create_uploadContainer__gemfF"};